/**
 * Org-wide default Overview dashboard — Vector Capital sections as widgets.
 *
 * Shown to every signed-in user as the first item in the dashboard picker.
 * Admin/VectorAdmin publish layout changes via PUT /api/dashboards/default-template.
 * Code defaults below apply when the server row is empty or unpublished.
 */

import {
  OVERVIEW_TEST_LAYOUT,
  OVERVIEW_TEST_WIDGETS,
} from '../vectorCapital/vectorCapitalOverviewTestTemplate';
import { getEntityDisplayName } from '../../utils/activeEntity';

export const VECTOR_DASHBOARD_ID = 'vector-dashboard';
/** Fallback name. Prefer orgDashboardName() so the brand names its own board. */
export const VECTOR_DASHBOARD_NAME = 'Brand Dashboard';

/**
 * "<Brand> Dashboard" for the org-wide board. The ID stays `vector-dashboard`
 * — it is a stable key, not a label, and renaming it would orphan every stored
 * dashboard preference.
 */
export function orgDashboardName() {
  return `${getEntityDisplayName()} Dashboard`;
}

export function buildVectorDashboard({ markDefault = true } = {}) {
  return {
    id: VECTOR_DASHBOARD_ID,
    name: orgDashboardName(),
    is_default: !!markDefault,
    is_system: true,
    layout: {
      order: [...OVERVIEW_TEST_LAYOUT.order],
      hidden: [...OVERVIEW_TEST_LAYOUT.hidden],
      sizes: Object.fromEntries(
        Object.entries(OVERVIEW_TEST_LAYOUT.sizes).map(([id, p]) => [id, { ...p }]),
      ),
    },
    widgets: OVERVIEW_TEST_WIDGETS.map((w) => ({
      id: w.id,
      type: w.type,
      config: { ...(w.config || {}) },
    })),
  };
}

export function isVectorDashboardId(id) {
  return id === VECTOR_DASHBOARD_ID;
}
